const shopImages = import.meta.glob('../imgs/Shops/*.(png|jpg|jpeg|svg|webp)', { eager: true }) as Record<string, { default: string }>

// Normalize string by removing invisible Unicode characters (RTL markers, zero-width chars, etc.)
const normalizeKey = (str: string): string => {
  return str.replace(/[\u200B-\u200D\uFEFF\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '').trim()
}

// Create a mapping of brand names to their image URLs
const brandLogoMap: Record<string, string> = {}

// Process the imported images
Object.entries(shopImages).forEach(([path, module]) => {
  // Extract the filename without extension from the path
  const filename = path!
    .split('/')!
    .pop()!
    .replace(/\.(png|jpg|jpeg|svg|webp)$/, '')
  const normalizedKey = normalizeKey(filename)
  // Store both the original and normalized key for backwards compatibility
  brandLogoMap[filename] = module!.default
  brandLogoMap[normalizedKey] = module!.default
})

export const getBrandLogo = (brand: string) => {
  const normalizedBrand = normalizeKey(brand)

  // Try to find the exact brand match (normalized)
  if (brandLogoMap[normalizedBrand]) {
    return brandLogoMap[normalizedBrand]
  }

  // Try original brand name
  if (brandLogoMap[brand]) {
    return brandLogoMap[brand]
  }

  const extensions = ['png', 'jpg', 'jpeg', 'svg', 'webp']
  for (const ext of extensions) {
    const key = `${normalizedBrand}.${ext}`
    if (brandLogoMap[key]) {
      return brandLogoMap[key]
    }
  }

  // Fallback to Other.png
  return brandLogoMap['Other'] || brandLogoMap['Other.png']
}
export const getBrandLogoWithoutFallback = (brand: string) => {
  const normalizedBrand = normalizeKey(brand)

  // Try to find the exact brand match (normalized)
  if (brandLogoMap[normalizedBrand]) {
    return brandLogoMap[normalizedBrand]
  }

  // Try original brand name
  if (brandLogoMap[brand]) {
    return brandLogoMap[brand]
  }

  const extensions = ['png', 'jpg', 'jpeg', 'svg', 'webp']
  for (const ext of extensions) {
    const key = `${normalizedBrand}.${ext}`
    if (brandLogoMap[key]) {
      return brandLogoMap[key]
    }
  }
  if (normalizedBrand === 'Other') {
    return brandLogoMap['Other'] || brandLogoMap['Other.png']
  }
  return null
}
